<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">To AARON ASHER<br/>whose editing, enthusiasm, and integrity<br/>made this book possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062029300_epub_ded_r1.vue?76bdd7f3